import React, { useEffect, useState } from "react";
// import * as Fa from "react-icons/fa";
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import { format } from "date-fns";
import Loader from "../../Components/Loader";
import * as Fa from "react-icons/fa";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";
import { toast } from "react-toastify";
const SchemeShortFall = () => {
    const [qtrData, setQtrData] = useState([]);
    const [selectedSchemes, setSelectedSchemes] = useState([]);
    const [selectedQtrData, setSelectedQtrData] = useState([]);
    const [ListofSchemes, setListofSchemes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingxl, setLoadingxl] = useState(false);

    const auth = storage.getLocal("user");
    const typeWise = [
        { name: "FOC", key: "FOC" },
        { name: "Value", key: "VAL" },
    ];
    const [selectedtypeWise, setSelectedTypeWise] = useState(typeWise[0]);

    useEffect(() => {
        const onPageload = async () => {
            try {
                const schmrpt = "Reports/SchemeShortfallQuarter?";
                const schmrptData = `${schmrpt}CompId=${auth.CompId}`;
                let dataresponse = await Axios.get(schmrptData);
                setQtrData(dataresponse?.data?.Data);
                setSelectedQtrData(dataresponse?.data?.Data[0]);
            } catch (error) {
                console.log(error);
            }
        };
        onPageload();
    }, []);

    useEffect(() => {
        const onPageload = async () => {
            try {
                setLoading(true);
                const allschmrpt = "Reports/SchemeShortfallSchemes?";
                const allschmrptData = `${allschmrpt}strYear=${selectedQtrData.YEAR_QUARTER_VALUE.toString().substring(
                    0,
                    4
                )}&strQuarter=${selectedQtrData.YEAR_QUARTER_VALUE.toString().charAt(
                    4
                )}&UserId=${auth.UserId}&strIsFOC=${
                    selectedtypeWise.key == "FOC" ? "Y" : null
                }`;
                let dataresponse = await Axios.get(allschmrptData);
                setListofSchemes(dataresponse.data.Data);
                // console.log(dataresponse);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        onPageload();
        setSelectedSchemes([]);
    }, [selectedtypeWise, selectedQtrData]);


    const getQuarterDates = (quarter, year) => {
        let startDate, endDate;
        const today = new Date();
        switch (quarter) {
        case 1:
            startDate = new Date(year, 0, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 2, 31);
            break;
        case 2:
            startDate = new Date(year, 3, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 5, 30);
            break;
        case 3:
            startDate = new Date(year, 6, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 8, 30);
            break;
        case 4:
            startDate = new Date(year, 9, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 11, 31);
            break;
        default:
            return null;
        }

        if (new Date(endDate).getTime() > new Date(today).getTime()) {
            endDate = new Date(today);
        }

        return { fromDate: startDate, toDate: endDate };
    };

    const datformat = (datestring) => {
        let dateconv = format(new Date(datestring), "dd/MM/yyyy");
        return dateconv;
    };

    const dowbloadDatascheme = async () => {
        if (selectedSchemes.length == 0) {
            toast.warning("Please select schemes", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        let getyear = selectedQtrData.YEAR_QUARTER_VALUE.toString().substring(0, 4);
        let getquarter = selectedQtrData.YEAR_QUARTER_VALUE.toString().substring(4);
        let getquaterdata = getQuarterDates(parseInt(getquarter), getyear);
        let listschemes = selectedSchemes.map((item) => `${item.SCHEME_ID}`).join(
            "~"
        );
        try {
            let reptname = `SchemeShortfallReport${GetDateFormat()}.xlsx`;
            setLoadingxl(true);
            const allschmrpt = "Reports/SchemeShortfallReport?";
            const allschmrptData = `${allschmrpt}CompId=${
                auth.CompId
            }&FromDate=${datformat(getquaterdata.fromDate)}&ToDate=${datformat(
                getquaterdata.toDate
            )}&year=${getyear}&Quarter=${getquarter}&schemes=${listschemes}`;
            let dataresponse = await Axios.get(allschmrptData);
            if (dataresponse?.data?.Data?.length == 0) {
                toast.info("No data found.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            } else {
                downloadExcel(dataresponse.data.Data, reptname);
            }
            setSelectedSchemes([]);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingxl(false);
        }
    };
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Scheme Short Fall Report</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={dowbloadDatascheme}
                                disabled={loadingxl}
                            >
                                {loadingxl ? "Loading..." : "Download Report"}{" "}
                                {loadingxl ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaDownload className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <label className="form-label">Quarter</label>
                                <Dropdown
                                    value={selectedQtrData}
                                    onChange={(e) => {
                                        setSelectedQtrData(e.value);
                                    }}
                                    options={qtrData}
                                    optionLabel="YEAR_QUARTER_TEXT"
                                    //   disabled
                                />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <label className="form-label d-block">Scheme Type</label>
                                <div className="d-inline-flex">
                                    {typeWise.map((doc) => {
                                        return (
                                            <div key={doc.key} className="flex align-items-center">
                                                <RadioButton
                                                    inputId={doc.key}
                                                    name="doc"
                                                    value={doc}
                                                    onChange={(e) => setSelectedTypeWise(e.value)}
                                                    checked={selectedtypeWise.key === doc.key}
                                                />
                                                <label htmlFor={doc.key} className="mx-2">
                                                    {doc.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12"></div>
                        </div>
                    </form>
                </section>
                <section className="mt-3">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3 className="py-2">List of Schemes</h3>
                        {loading ? (
                            <>
                                <Loader />
                            </>
                        ) : (
                            <>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="DataTable">
                                        <DataTable
                                            value={ListofSchemes}
                                            rows={10}
                                            filterDisplay="row"
                                            // showGridlines
                                            stripedRows
                                            selectionMode="checkbox"
                                            scrollHeight="80vh"
                                            scrollable
                                            selection={selectedSchemes}
                                            onSelectionChange={(e) => {
                                                setSelectedSchemes(e.value);
                                            }}
                                        >
                                            <Column
                                                header="Select All"
                                                selectionMode="multiple"
                                                headerStyle={{ width: "5rem" }}
                                            ></Column>
                                            <Column
                                                field="SCHEME_NAME"
                                                header="Schemes Name"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </section>
            </div>
        </>
    );
};

export default SchemeShortFall;
